































































































































































































































import Vue from "vue";
import axios from 'axios';
import VueJsonToCsv from "vue-json-to-csv";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import SideTabs from "@/parts/mypage/SideTabs.vue";
import PageTabs from "@/parts/mypage/Tabs.vue";
import PrevNext from "@/parts/mypage/PrevNext.vue";
import SelectBox from "@/components/util/SelectBox.vue";
import VariableInput from "@/components/util/VariableInput.vue";
import moment from "moment";
import { sortedByDateDesc } from "@/utils/momentUtils";
import { convertToKana, convertToHalfKana, getByteLength } from "@/utils/stringUtil";

import { SaleResponse, SaleDetailResponse } from "@/api/dto/Sale";
import { AccountPayable } from "@/api/dto/AccountPayable";
import { Bank } from "@/api/dto/Banks";
import { getUserProfile, updatePaymentInformation } from "@/api/UserProfile";
import { getSales, getSaleDetails } from "@/api/Sale";
import { getBanks } from "@/api/Banks";
import { ErrorResponse } from '@/api/dto/Error';

interface Data {
  // 処理中にtrueになる
  isApiProcessing: boolean;
  tabs: [
    { mode: 'statements', text: '売上明細' },
    { mode: 'past', text: '過去の売上' },
    { mode: 'account', text: 'お振込先' },
  ],
  today: moment.Moment;
  periodFrom: string;
  periodTo: string;
  showNum: number;
  showNumOptions: Array<{ value: number; text: string }>;
  csvLabelsSaleDetail: {
    completeDate : { title: '取引完了日' },
    dealId : { title: '取引ID' },
    title : { title: 'タイトル' },
    amount : { title: '金額' },
  },
  csvTitleSaleDetail: string;
  saleDetailData: SaleDetailResponse[];
  pageSaleDetail: number;
  // 過去の売上 関連
  periodPast: number,
  periodPastOptions: Array<{ value: number; text: string }>;
  csvLabelsSale: {
    salesMonth : { title: '売上月' },
    amount : { title: '金額' },
    paymentDay : { title: '入金日' },
    status : { title: 'ステータス' },
  },
  csvTitleSale: string;
  saleData: SaleResponse[];
  // ===========================================================================
  // お振込先 関連
  // ===========================================================================
  accountPayableInfo: [
    { key: 'bankName', name: '銀行名', type: 'text', placeholder: 'みずほ銀行', error: '' },
    { key: 'branchName', name: '支店名', type: 'text', placeholder: 'コード支店', error: '' },
    { key: 'savingType', name: '預金種類', type: 'text', placeholder: '', error: '' },
    { key: 'accountNumber', name: '口座番号', type: 'number', placeholder: '1234567', error: '' },
    { key: 'accountHolder', name: '口座名義カナ', type: 'text', placeholder: 'コード　タロウ', error: '' },
  ],
  accountPayableForm: AccountPayable;
  /** 銀行名のリスト（銀行名のサジェストに使用） */
  bankList: {
    bankCode: string;
    bankName: string;
    bankNameKana: string;
  }[];
  /** 銀行名をキーにした支店情報（支店名のサジェストに使用） */
  bankBranchMap: Map<
    string,
    {
      /** 支店コード */
      branchCode: string;
      /** 支店名 */
      branchName: string;
      /** 支店名カナ */
      branchNameKana: string;
    }[]
  >;
  /** vue-simple-suggest のスタイルクラス */
  suggestStyle: {
    vueSimpleSuggest: string;
    inputWrapper: string;
    defaultInput: string;
    suggestions: string;
    suggestItem: string;
  };
}

export default Vue.extend({
  name: 'SalesManagement',
  components: {
    VueJsonToCsv,
    VueSimpleSuggest,
    SideTabs,
    PageTabs,
    PrevNext,
    SelectBox,
    VariableInput,
  },
  props: {
    modeName: String,
  },
  data(): Data {
    this.$store.commit('setMode', { mode: this.modeName == 'account' ? 'account' : this.modeName == 'past' ? 'past' : 'statements' });
    return {
      isApiProcessing: false,
      tabs: [
        { mode: 'statements', text: '売上明細' },
        { mode: 'past', text: '過去の売上' },
        { mode: 'account', text: 'お振込先' },
      ],
      today: moment(),
      // 売上明細 関連
      periodFrom: '',
      periodTo: '',
      showNum: 20,
      showNumOptions: [
        { value: 20, text: '20件' },
        { value: 50, text: '50件' },
        { value: 100, text: '100件' },
      ],
      csvLabelsSaleDetail: {
        completeDate : { title: '取引完了日' },
        dealId : { title: '取引ID' },
        title : { title: 'タイトル' },
        amount : { title: '金額' },
      },
      csvTitleSaleDetail: 'code_sales_details',
      saleDetailData: [],
      pageSaleDetail: 1,
      // 過去の売上 関連
      periodPast: 0,
      periodPastOptions: [],
      csvLabelsSale: {
        salesMonth : { title: '売上月' },
        amount : { title: '金額' },
        paymentDay : { title: '入金日' },
        status : { title: 'ステータス' },
      },
      csvTitleSale: 'code_sales',
      saleData: [],
      // お振込先 関連
      accountPayableInfo: [
        { key: 'bankName', name: '銀行名', type: 'text', placeholder: 'みずほ銀行', error: '' },
        { key: 'branchName', name: '支店名', type: 'text', placeholder: 'コード支店', error: '' },
        { key: 'savingType', name: '預金種類', type: 'text', placeholder: '', error: '' },
        { key: 'accountNumber', name: '口座番号', type: 'number', placeholder: '1234567', error: '' },
        { key: 'accountHolder', name: '口座名義カナ', type: 'text', placeholder: 'コード　タロウ', error: '' },
      ],
      accountPayableForm: {} as AccountPayable,
      bankList: [],
      bankBranchMap: new Map<
        string,
        {
          branchCode: string;
          branchName: string;
          branchNameKana: string;
        }[]
      >(),
      suggestStyle: {
        vueSimpleSuggest: "suggest-root",
        inputWrapper: "",
        defaultInput: "",
        suggestions: "suggestions",
        suggestItem: "suggest-list",
      },
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const res = sortedByDateDesc(await getSaleDetails(), it => it.completeDate);
      next(vm => (vm.$data as Data).saleDetailData = res);
    } catch (e) {
      next(false);
    }
  },
  async created() {
    await this.getBanks();
    await this.getSale();
    this.setInitialPeriodPast();
    await this.getUserProfile();
  },
  computed: {
    mode(): string {
      return this.$store.state.mode;
    },
    // 売上明細 関連
    detailThisMounthAmount(): number {
      var start = this.today.clone().startOf('months');
      var end = this.today.clone().endOf('months');
      var returnArray = this.saleDetailData.filter(v => moment(v.completeDate, 'YYYY/MM/DD HH:mm:ss').isBetween(start, end, null, '[]'));
      return returnArray.map(item => item.amount).reduce((prev, curr) => prev + curr, 0);
    },
    detailLastMounthAmount(): number {
      var last = this.today.clone().subtract(1, 'months');
      var start = last.clone().startOf('months');
      var end = last.clone().endOf('months');
      var returnArray = this.saleDetailData.filter(v => moment(v.completeDate, 'YYYY/MM/DD HH:mm:ss').isBetween(start, end, null, '[]'));
      return returnArray.map(item => item.amount).reduce((prev, curr) => prev + curr, 0);
    },
    detailTotalAmount(): number {
      return this.saleDetailData.map(item => item.amount).reduce((prev, curr) => prev + curr, 0);
    },
    filteredSaleDetail(): SaleDetailResponse[] {
      if(this.periodFrom && this.periodTo) {
        var start = moment(this.periodFrom);
        var end = moment(this.periodTo).endOf('days');
        return this.saleDetailData.filter(v => moment(v.completeDate, 'YYYY/MM/DD HH:mm:ss').isBetween(start, end, null, '[]'));
      } else if(this.periodFrom) {
        var start = moment(this.periodFrom);
        return this.saleDetailData.filter(v => moment(v.completeDate, 'YYYY/MM/DD HH:mm:ss').isSameOrAfter(start));
      } else if(this.periodTo) {
        var end = moment(this.periodTo).endOf('days');
        return this.saleDetailData.filter(v => moment(v.completeDate, 'YYYY/MM/DD HH:mm:ss').isSameOrBefore(end));
      } else {
        return this.saleDetailData;
      }
    },
    startNumSaleDetail(): number {
      return Math.min(this.showNum * (this.pageSaleDetail - 1) + 1, this.filteredSaleDetail.length);
    },
    endNumSaleDetail(): number {
      return Math.min(this.showNum * this.pageSaleDetail, this.filteredSaleDetail.length);
    },
    showSaleDetail(): SaleDetailResponse[] {
      return this.filteredSaleDetail.slice(this.startNumSaleDetail - 1, this.endNumSaleDetail);
    },
    totalPageSaleDetail(): number {
      return Math.ceil(this.filteredSaleDetail.length / this.showNum);
    },
    csvDataSaleDetail(): Array<{ [key: string]: string }> {
      if(this.showSaleDetail.length) {
        return this.showSaleDetail.map(item => {
          return {
            completeDate: this.$options.filters!.momentFormat(item.completeDate),
            dealId: item.dealId,
            title: item.title,
            amount: this.$options.filters!.amountLocaleString(item.amount) + '円',
          }
        });
      } else {
        return [
          {
            completeDate: '',
            dealId: '',
            title: '',
            amount: '',
          }
        ];
      }
    },
    // 過去の売上 関連
    filteredSale(): SaleResponse[] {
      var targetYear = this.periodPast.toString();
      return this.saleData.filter(v => v.year == targetYear);
    },
    pastTotalAmount(): number {
      return this.filteredSale.map(item => item.monthlySales).reduce((prev, curr) => prev + curr, 0);
    },
    csvDataSale(): Array<{ [key: string]: string }> {
      if(this.filteredSale.length) {
        return this.filteredSale.map(item => {
          return {
            salesMonth: this.$options.filters!.salesMonthFormat(item.month).replace(/\s+/g, ""),
            amount: this.$options.filters!.amountLocaleString(item.monthlySales) + '円',
            paymentDay: this.$options.filters!.paymentDayFormat(item.month),
            status: this.$options.filters!.statusFormat(item.transferStatus),
          }
        });
      } else {
        return [
          {
            salesMonth: '',
            amount: '',
            paymentDay: '',
            status: '',
          }
        ];
      }
    },
  },
  methods: {
    changeMode(key: string) {
      this.$store.commit('setMode', { mode: key });
    },
    thisMonthEnd(): string {
      return this.today.clone().endOf('months').format('M/D');
    },
    setPeriodFrom(value: string) {
      this.periodFrom = value;
      this.resetPage();
    },
    setPeriodTo(value: string) {
      this.periodTo = value;
      this.resetPage();
    },
    setShowNumOption(value: number) {
      if(this.showNum != value) {
        this.showNum = value;
        this.resetPage();
      }
    },
    onPageChange(currentPage: number) {
      this.pageSaleDetail = currentPage;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    resetPage() {
      this.pageSaleDetail = 1;
    },
    // 過去の売上 関連
    async getSale() {
      try {
        const res = await getSales();
        this.saleData = res.sort((a, b) => -this.compareByMonth(a.month, b.month));
      } catch (e) {
        console.log(e);
      }
    },
    compareByMonth(a: string, b: string) {
      if(a > b) {
        return 1;
      } else {
        return -1;
      }
    },
    setInitialPeriodPast() {
      var array = this.saleData.map(item => item.year).filter((v, i, self) => self.indexOf(v) == i);
      if(array.length) {
        this.periodPast = Math.max(...array.map(Number));
        this.periodPastOptions = array.map(item => {
          return { value: Number(item), text: item+'年'}
        });
      } else {
        var thisYear = Number(this.today.format('YYYY'));
        this.periodPast = thisYear;
        this.periodPastOptions.push({ value: thisYear, text: thisYear+'年' });
      }
    },
    setPeriodPastOption(value: number) {
      this.periodPast = value;
    },
    // =========================================================================
    // お振込先 関連
    // =========================================================================
    /** 銀行マスタ取得 */
    async getBanks() {
      const response = await getBanks();

      response.forEach((bankItem) => {
        if (!this.bankBranchMap.get(bankItem.bankName)) {
          // 銀行名をキーに支店情報を格納
          const filteredBanks = response.filter(
            (bank) => bank.bankName === bankItem.bankName
          );

          const branches = filteredBanks.map((branchItem) => ({
            branchCode: branchItem.branchCode,
            branchName: branchItem.branchName,
            branchNameKana: branchItem.branchNameKana,
          }));
          this.bankBranchMap.set(bankItem.bankName, branches);

          // 銀行情報の配列に格納
          this.bankList.push({
            bankCode: bankItem.bankCode,
            bankName: bankItem.bankName,
            bankNameKana: bankItem.bankNameKana,
          });
        }
      });
    },
    /** 銀行名のサジェスト */
    getFilteredBanks(currentValue: string) {
      // 入力値を半角カナへ変換
      const kana = convertToKana(currentValue);
      const halfKana = convertToHalfKana(kana);

      // 半角カナの銀行名から前方一致するものを返す
      const filteredByHalfKana = this.bankList.filter((bankItem) =>
        new RegExp(`^${halfKana}`, "g").test(bankItem.bankNameKana)
      );
      if (filteredByHalfKana.length) {
        return [...filteredByHalfKana];
      }

      // 銀行名から前方一致するものを返す
      return this.bankList.filter((bankItem) =>
        new RegExp(`^${currentValue}`, "g").test(bankItem.bankName)
      );
    },
    /**  銀行名 blur ハンドラ */
    handleBlurBankName() {
      const currentValue = this.accountPayableForm.bankName;
      const matchedBank = this.bankList.find(
        (bankItem) => bankItem.bankName === currentValue
      );
      // 銀行名から銀行コードを取得しセット
      this.accountPayableForm.bankCode = matchedBank?.bankCode ?? "";

      // 選択中の支店コードのチェック・更新
      this.updateBranchCode();
    },
    /** 銀行名サジェスト click ハンドラ */
    handleSelectBankName({ bankCode }: Bank) {
      // 銀行名から銀行コードを取得しセット
      this.accountPayableForm.bankCode = bankCode ?? "";

      // 選択中の支店コードのチェック・更新
      this.updateBranchCode();
    },
    /** 支店名のサジェスト */
    getFilteredBranches(currentValue: string) {
      // 選択中の銀行名から支店情報を取得
      const branches =
        this.bankBranchMap.get(this.accountPayableForm.bankName) ?? [];

      // 入力値を半角カナへ変換
      const kana = convertToKana(currentValue);
      const halfKana = convertToHalfKana(kana);

      // 半角カナの支店名から前方一致するものを返す
      const filteredByHalfKana = branches.filter((branchItem) =>
        new RegExp(`^${halfKana}`, "g").test(branchItem.branchNameKana)
      );

      if (filteredByHalfKana.length) {
        return filteredByHalfKana;
      }

      // 支店名から前方一致するものを返す
      return branches.filter((branchItem) =>
        new RegExp(`^${currentValue}`, "g").test(branchItem.branchName)
      );
    },
    /** 支店名 blur ハンドラ */
    handleBlurBranch() {
      this.updateBranchCode();
    },
    /** 支店名 focus ハンドラ */
    handleFocusBranch() {
      // 選択している銀行名が変更されている場合、紐づく支店名も変わるため再度フィルタリングする
      const branchNameRef = (this.$refs.branchNameSuggest as any)[0];
      branchNameRef.suggestions = this.getFilteredBranches(
        this.accountPayableForm.branchName
      );
    },
    /** 支店名サジェスト click ハンドラ */
    handleSelectBranch({ branchCode }: Bank) {
      this.accountPayableForm.branchCode = branchCode ?? "";
    },
    /**
     * 設定した支店名に合致する支店コードをセット
     * NOTE: 銀行名 or 支店名変更時に都度更新
     */
    updateBranchCode() {
      // 銀行名と支店名から支店コード取得し、state へセット
      const currentBranchName = this.accountPayableForm.branchName;
      const branchList =
        this.bankBranchMap.get(this.accountPayableForm.bankName) ?? [];
      const matchedBranch = branchList.find(
        (branchItem) => branchItem.branchName === currentBranchName
      );
      this.accountPayableForm.branchCode = matchedBranch?.branchCode ?? "";
    },
    /** ユーザー情報取得 */
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        const resAccountPayable = res.accountPayable;
        this.accountPayableForm = {
          bankCode: resAccountPayable?.bankCode ?? '',
          bankName: resAccountPayable?.bankName ?? '',
          branchCode: resAccountPayable?.branchCode ?? '',
          branchName: resAccountPayable?.branchName ?? '',
          savingType: resAccountPayable?.savingType ?? '',
          accountNumber: resAccountPayable?.accountNumber ?? '',
          accountHolder: resAccountPayable?.accountHolder ?? '',
        }
      } catch (e) {
        console.log(e);
      }
    },
    /** 口座名義の変換 */
    setAccountHolder(value: string) {
      this.accountPayableForm.accountHolder = convertToKana(value);
    },
    /** 更新前バリデーション */
    validation(): string | undefined {
      // 入力値有無チェック
      const { bankCode, branchCode, ...restFormItem } = this.accountPayableForm;
      if (!Object.values(restFormItem).every((value) => !!value)) {
        return "未入力の項目があります";
      }

      // 口座番号の桁数チェック
      if (this.accountPayableForm.accountNumber.length !== 7) {
        return "口座番号は7桁で入力してください";
      }

      // 口座名義に不正な文字が使われていないか
      if (
        !/^[ァ-ヶー　）（Ａ-Ｚ０-９／‐「」．]+$/.test(
          this.accountPayableForm.accountHolder
        )
      ) {
        return "口座名義は全角カナ、全角空白、全角英数字（英は大文字）、一部の全角記号( ) . - / のみ入力してください";
      }

      // 口座名義の桁数チェック
      if (getByteLength(this.accountPayableForm.accountHolder) > 71) {
        // バイト数をチェックし、バイト数71(全角文字にして大体23.5桁)を超える場合はエラー
        return "口座名義は23桁以下で入力してください。※23桁を超える口座名義の場合は省略せず、入力可能な23桁までを入力してください";
      }

      // 銀行名・支店名が正しく入力されているかのチェック
      // NOTE: 銀行名、支店名が不正もしくは未入力の場合はそれぞれのコードが空になります
      if (
        !this.accountPayableForm.bankCode ||
        !this.accountPayableForm.branchCode
      ) {
        return "銀行名・支店名を正しく入力してください";
      }

      return;
    },
    /** 振込先更新 */
    async updateAccountPayable() {
        this.isApiProcessing = true;
        
        // 入力値のバリデーションチェック
        const validationMessage = this.validation();
        if (validationMessage) {
          this.$emit("errorToast", validationMessage);
          return;
        }

        await updatePaymentInformation(this.accountPayableForm)
          .catch(e => {
            // this.$emit('errorToast', '更新に失敗しました。時間おいて再度お試しください');
            if (e.message == null) {
                this.$emit("errorToast", "更新に失敗しました。時間おいて再度お試しください");
              } else {
                this.$emit('errorToast', e.message);
              }  
            throw e;
          });
        this.$emit('toast', 'お振込情報を更新しました');
        this.isApiProcessing = false;
    },
    /** 必須項目が未入力または入力形式が異なる場合、更新するボタンを非活性にする */ 
    isDisabled(){
      if(
         !this.accountPayableForm.bankCode ||
         !this.accountPayableForm.branchCode ||
         !this.accountPayableForm.savingType ||
         !this.accountPayableForm.bankName ||
         !this.accountPayableForm.accountNumber ||
         !this.accountPayableForm.accountHolder ||
         this.validation()
      ) {
          return this.isApiProcessing = true;
      } else {
        return this.isApiProcessing = false;
      }
    },
  },
  filters: {
    amountLocaleString: function(amount: number) {
      if(amount){
        return amount.toLocaleString();
      } else { // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
    momentFormat: function(date: Date) {
      return moment(date, 'YYYY/MM/DD HH:mm:ss').format('YYYY/M/D');
    },
    salesMonthFormat: function(string: string) {
      return moment(string, 'YYYYMM').format('YYYY 年 M 月分');
    },
    paymentDayFormat: function(string: string) {
      return moment(string, 'YYYYMM').add(1, 'months').endOf('months').format('YYYY/M/D');
    },
    statusFormat: function(string: string) {
      switch(string) {
        case '1':
          return '振込待ち';
        case '2':
          return '振込済み';
        case '3':
          return '振込失敗';
        case '4':
          return '翌月繰越';
        case '5':
          return '振込不要';
      }
    },
  },
})
